const calculatePrice = (unitPrice, quantity, basePrice) => {
  return unitPrice * quantity + basePrice;
};

export const fns = {
  series: {
    toFormSelectOption: (seriesReferences) => {
      return seriesReferences.map((x) => ({
        id: x.seriesId,
        label: x.name,
      }));
    },
  },
  productOption: {
    calculatePrice: (unitPrice, quantity, basePrice) => {
      return calculatePrice(unitPrice, quantity, basePrice);
    },
    calculateAndAttachPrice: (options, quantity, originalProductOption) =>
      options.map((option) => {
        if (
          originalProductOption &&
          originalProductOption.productOptionId === option.id
        ) {
          option.step3Price = originalProductOption.step3Price;
          option.step3Msrp = originalProductOption.step3Msrp;
        } else {
          option.step3Price = calculatePrice(
            option.unitStep3Price,
            quantity,
            option.baseStep3Price
          );
          option.step3Msrp = calculatePrice(
            option.unitStep3Msrp,
            quantity,
            option.baseStep3Msrp
          );
        }
        return option;
      }),
  },
};

export class OptionSetInfo {
  constructor(
    optionSet,
    allProductOptionSeries,
    quantity,
    preferredBrandId,
    preferredSeriesId,
    hasAvailableOptions,
    hideFromUser
  ) {
    optionSet.productOptionsBySeries.forEach((x) => {
      x.name = allProductOptionSeries.find(
        (series) => series.id === x.seriesId
      ).name;
    });
    this.optionSet = optionSet;
    this.quantity = quantity;
    this.preferredBrandId = preferredBrandId;
    this.preferredSeriesId = preferredSeriesId;
    this.hasAvailableOptions = hasAvailableOptions;
    this.hideFromUser = hideFromUser;
  }

  isSingleSeries() {
    return this.optionSet.productOptionsBySeries.length === 1;
  }

  includesBrand(brandId, allBrands) {
    return !!this.getFirstProductOptionGroupFromBrand(brandId, allBrands);
  }

  getFirstProductOptionGroupFromBrand(brandId, allBrands) {
    return this.optionSet.productOptionsBySeries.find((group) => {
      const brand = allBrands.find((x) =>
        x.series.some((y) => y.id === group.seriesId)
      );
      return brand.id === brandId;
    });
  }

  includesSeries(seriesId) {
    return this.optionSet.productOptionsBySeries.some(
      (x) => x.seriesId === seriesId
    );
  }

  getSeries(seriesId) {
    if (this.isSingleSeries()) {
      return this.optionSet.productOptionsBySeries[0];
    } else {
      return this.optionSet.productOptionsBySeries.find(
        (x) => x.seriesId === seriesId
      );
    }
  }

  getAvailableProductOptionIds() {
    const availableOptionIds = [];
    for (var j = 0; j < this.optionSet.productOptionsBySeries.length; j++) {
      const productOptionBySeries = this.optionSet.productOptionsBySeries[j];

      for (var k = 0; k < productOptionBySeries.productOptions.length; k++) {
        const productOption = productOptionBySeries.productOptions[k];

        if (productOption.available) {
          availableOptionIds.push(productOption.id);
        }
      }
    }
    return availableOptionIds;
  }
}
